export const removeTaskData = () => {
  // remove TO Bin task data from local storage
  localStorage.removeItem("taskId");
  localStorage.removeItem("selectedBin");
};
